module.exports = __webpack_public_path__ + "img/film-threat-optimization-1.7d92ce86.svg";